<template>
  <div class="address">
      <!-- 填写收货地址弹框 -->
        <div class="shipping-address-content">
            <div class="input_box1 flex align-items-center">
                <div class="input_title flex align-items-center">收货人<span>*</span></div>
                <div class="input"><input type="text" id="" placeholder="请输入收货人姓名" v-model="consignee"></div>
            </div>
            <div class="input_box2 flex align-items-center">
                <div class="input_title flex align-items-center">手机号码<span>*</span></div>
                <div class="input"><input type="number" id="" placeholder="请输入手机号" oninput="if(value.length>11)value=value.slice(0,11)" v-model="phoneNumber"></div>
            </div>
            <!-- <div class="input_box2 flex flex-direction-row flex-wrap-no justify-content-center">
                <div class="input_title">地区</div>
                <div class="input"><input type="text" id="" placeholder="请输入地区" v-model="province"></div>
            </div> -->
            <div class="input_box3 flex align-items-center">
                <div class="input_title flex align-items-center">地区选择<span>*</span></div>
                <div class="input flex align-items-center">
                    <div class="province" @click.stop="clickprovince('p')">{{province}}</div>
                    <div class="provincebox" v-if="isshowprovince">
                        <div class="select-con">
                            <div class="bordergrey" v-for="(item, index) in provincearr" :key="index" @click.stop="selectitem(item,'p')" >{{item}}</div>
                        </div>
                    </div>
                    <div class="city" @click.stop="clickprovince('c')">{{city}}</div>
                    <div class="provincebox city-select" v-if="isshowcity">
                        <div class="select-con">
                            <div class="bordergrey" v-for="(item, index) in cityarr" :key="index" @click.stop="selectitem(item,'c')" >{{item}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="input_box4 flex align-items-start">
                <div class="input_title flex align-items-center">详细地址<span>*</span></div>
                <div class="input input_title_address"><textarea id="" rows="3" placeholder="请输入详细地址" v-model="deliveryAddress"></textarea></div>
            </div>
            <div class="input_box5" style="margin-bottom: 0rem;">
            <!-- <div class="input_box5"> -->
                <div class="prize">
                    <span class="input_title">已获得奖品</span>
                    <span class="input_title" style="display:block;text-align:left;font-size:0.26rem;">(实物奖品于活动结束后的20个工作日内发放)</span>
                </div>
                <div class="prize-list flex flex-wrap justify-content-between">
                    <div class="prize-img" v-for="(item,index) in acquirePrizes" :key="index">
                        <div class="prize-img-box flex align-items-center justify-content-center">
                            <img :src="item.url" alt="">
                        </div>
                        <div class="prize-title">{{item.name}}</div>
                        <div class="prize-num">X{{item.num}}</div>
                    </div>
                    <div class="prize-no" v-if="prizeOf">暂无奖品</div>
                </div>
                
            </div>
            <div class="input_box5">
                <div class="prize">
                    <span class="input_title">双十一兑换券</span>
                    <span class="input_title" style="display:block;text-align:left;font-size:0.26rem;">(实物奖品于活动结束后的20个工作日内发放)</span>
                </div>
                <div class="prize-list flex flex-wrap justify-content-between">
                    <div class="prize-img" v-for="(item,index) in tenPrizeInfo" @click="doubleElevenCoinCertificate=true" :key="index">
                        <div class="prize-img-box flex align-items-center justify-content-center">
                            <img :src="item.url" alt="">
                        </div>
                        <div class="prize-title">{{item.name}}</div>
                        <div class="prize-num">X{{item.num}}</div>
                    </div>
                    <!-- <div class="prize-no" v-if="prizeOf">暂无奖品</div> -->
                </div>
                
            </div>
            <div class="btn-box">
                <div class="edit_address_btn" @click="save_address"></div>
                <div class="btn-title">实物奖品将于活动结束后20个工作日内发放</div>
            </div>
        </div>
        <div class="toast" v-if="toastPopup">{{toastContent}}</div>
            <!-- 双十一兑换券提醒 -->
        <div class="mask" v-if="doubleElevenCoinCertificate || loading">
            <div class="double-eleven-coin-certificate positionabsolute" v-if="doubleElevenCoinCertificate">
                <div class="close-acquisition" @click="closedoubleElevenCoinCertificate"></div>
            </div>
           <div class="loading positionabsolute" v-if="loading">
                <div class="pswp__preloader__icn">
                    <div class="pswp__preloader__cut">
                      <div class="pswp__preloader__donut"></div>
                    </div>
                  </div>
                  <div class="title">
                      数据加载中
                  </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            doubleElevenCoinCertificate:false,  //双十一兑换券提示框
            toastPopup:false,
            toastContent:'',
            consignee:'',   //收货人
            phoneNumber:'',  //收货手机号码
            province:'请选择',
            city:'请选择',
            isshowprovince:false,
            provincearr: ["北京市","天津市","河北省","山西省","内蒙古","辽宁省","吉林省","黑龙江省","上海市","江苏省","浙江省","安徽省","福建省","江西省","山东省","河南省","湖北省","湖南省","广东省","广西自治区","海南省","重庆市","四川省","贵州省","云南省","西藏自治区","陕西省","甘肃省","青海省","宁夏回族自治区","新疆维吾尔自治区","香港特别行政区","澳门特别行政区","台湾省","其它",],
            cityarr:[],
            isshowcity:false,
            deliveryAddress:'',
            prize:'奖品',
            userToken:window.localStorage.getItem('zebra-token'),
            // userToken:'8af9002e717348a88d21a208abf7a9be-prod_SAIC',
            // userToken:'3c25eac975304e64bc9a3c56767b4b77-qa_SAIC',
            acquirePrizes:[],
            prizeOf:false,
            tenPrizeInfo:[],
            prizelist:[],
            loading:false
        }
    },
    created(){
        // let arr=[]
        // arr = this.qc(JSON.parse(this.$route.query.acquirePrizes))
        // arr.map((v)=>{
        //     if(v.name=='50积分' || v.name=='爱车之路获得22积分' || v.name=='爱车之路获得50积分' || v.name=='爱车之路获得66积分'){
        //         this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110284a396d54e225d9cb278572.png',num:v.num})
        //     }else if(v.name=='酷我音乐月卡'){
        //         this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110289f808dad59bbb3e2157283.png',num:v.num})
        //     }else if(v.name=='猫眼电影券'){
        //         this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211028bb80d570b49a4533334650.png',num:v.num})
        //     }else if(v.name=='大嘴猴 Paul Frank 保温杯'){
        //         this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211028094b847e9d389a32878374.png',num:v.num})
        //     }else if(v.name=='米家桌面暖风机'){
        //         this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021102856eff1aae09c7547245857.png',num:v.num})
        //     }else if(v.name=='卡西欧2021 BATTLE G-SHOCK 王一博同款'){
        //         this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110280289c785eaab2053820259.png',num:v.num})
        //     }else if(v.name=='Airpods pro'){
        //         this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211028fa7d81863e39b70a405751.png',num:v.num})
        //     }else if(v.name=='车载吸尘器套装'){
        //         this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021102830627dc6ff8334b9633200.png',num:v.num})
        //     }
        // })
        let arr1=[]
        arr1 = this.qc(JSON.parse(window.localStorage.getItem('tenPrizeInfo')))
        arr1.map((v)=>{
            if(v.name=='券：猫眼电影通兑券'){
                this.tenPrizeInfo.push({name:v.name,url:'//res.xiaoxxx.com/test/m.xiaoxxx.com/20211019c575b50ea650ebe7171819.png',num:v.num})
            }else if(v.name=='券：Surface Laptop Go i5 （256G）'){
                this.tenPrizeInfo.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021af0c790a289a77bf597686.jpg',num:v.num})
            }else if(v.name=='券：倍轻松（breo）腰部按摩器'){
                this.tenPrizeInfo.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110210ba3f420ea067d56138119.jpg',num:v.num})
            }else if(v.name=='券：小米除螨仪家用手持除螨机'){
                this.tenPrizeInfo.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211021a12c50a62cd01972830943.jpg',num:v.num})
            }else if(v.name=='券：犇犇的小野牛巨型零食包'){
                this.tenPrizeInfo.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110219a0af5bac6f5da2e213154.jpg',num:v.num})
            }
        })
        // if(this.acquirePrizes.length==0){
        //     this.prizeOf = true
        // }
        // let addressList = JSON.parse(this.$route.query.address)
        // if(JSON.stringify(addressList)=='null'||JSON.stringify(addressList)=='{}'){
        //     console.log('11')
        // }else{
        //     this.consignee = addressList.username
        //     this.phoneNumber = addressList.mobile
        //     this.province = addressList.province
        //     this.deliveryAddress = addressList.detailAddress
        //     this.city = addressList.city
        // }
        this.loading = true
        this.getAddressList()
    },
    methods:{
        getAddressList(){
            this.$http.post("/getUserAddress", {
                brandCode: "1", // 1:荣威，2:名爵
            }).then((res) => {
                if(res.data.code==0){
                    if(res.data.data.userAddressInfo){
                        this.consignee = res.data.data.userAddressInfo.username
                        this.phoneNumber = res.data.data.userAddressInfo.mobile
                        this.province = res.data.data.userAddressInfo.province
                        this.deliveryAddress = res.data.data.userAddressInfo.detailAddress
                        this.city = res.data.data.userAddressInfo.city
                    }
                    res.data.data.prizeInfo.map((v)=>{
                        this.prizelist.push(v.prize_name)
                    })
                    let arr=[]
                    arr = this.qc(this.prizelist)
                    arr.map((v)=>{
                        if(v.name=='50积分' || v.name=='爱车之路获得22积分' || v.name=='爱车之路获得50积分' || v.name=='爱车之路获得66积分'){
                            this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110284a396d54e225d9cb278572.png',num:v.num})
                        }else if(v.name=='酷我音乐月卡'){
                            this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110289f808dad59bbb3e2157283.png',num:v.num})
                        }else if(v.name=='猫眼电影券'){
                            this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211028bb80d570b49a4533334650.png',num:v.num})
                        }else if(v.name=='大嘴猴 Paul Frank 保温杯'){
                            this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211028094b847e9d389a32878374.png',num:v.num})
                        }else if(v.name=='米家桌面暖风机'){
                            this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021102856eff1aae09c7547245857.png',num:v.num})
                        }else if(v.name=='卡西欧2021 BATTLE G-SHOCK 王一博同款'){
                            this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110280289c785eaab2053820259.png',num:v.num})
                        }else if(v.name=='Airpods pro'){
                            this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211028fa7d81863e39b70a405751.png',num:v.num})
                        }else if(v.name=='车载吸尘器套装'){
                            this.acquirePrizes.push({name:v.name,url:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021102830627dc6ff8334b9633200.png',num:v.num})
                        }
                    })
                    if(this.acquirePrizes.length==0){
                        this.prizeOf = true
                    }
                }
                this.loading = false
            })
        },
        // 关闭双十一兑换券提示框
        closedoubleElevenCoinCertificate(){
            this.doubleElevenCoinCertificate = false
        },
        qc(arr) {
            let tempArr = []
            let obj = {}
            let resultArr = []
            arr.forEach(v=>{
                if(!tempArr.includes(v)) {
                    tempArr.push(v)
                }
            })
            arr.forEach(v=>{
                if(obj[v]) {
                    obj[v]++
                }else {
                    obj[v] = 1
                }
            })
            tempArr.forEach(v=>{
                resultArr.push({name: v,num: obj[v]})
            })
            return resultArr
        },
        // 保存地址
        save_address(){
            
            let username = this.consignee.split(/[ ]+/).join('')
            // .replaceAll(" ","");
            let tel = this.phoneNumber.split(/[ ]+/).join('')
            let detail = this.deliveryAddress.split(/[ ]+/).join('')
            if (username != '') {
                if (username.length>=2 &&username.length<=6) {
                    if (tel != '') {
                        if (tel[0]=='1'&&tel.length==11) {
                            if (this.province != '' && this.province != '请选择') {
                                if (detail != '') {
                                    this.toastContent = '开始保存'; this.toastPopup = true
                                    this.$http.post("/addressCreate", {
                                        token: this.userToken,
                                        username:username,
                                        mobile:tel,
                                        province:this.province,
                                        city:this.city,
                                        detailAddress:detail,
                                        brandCode: "1", // 1:荣威，2:名爵
                                    }).then((res) => {
                                        this.toastPopup = false
                                        if(res.data.code==0){
                                            this.toastContent = '修改成功'; this.toastPopup = true
                                            setTimeout(() => {  this.toastPopup = false;this.$router.push({path:'/home'})}, 2000);
                                        }else{
                                            this.toastContent = res.data.message; this.toastPopup = true
                                            setTimeout(() => {  this.toastPopup = false;}, 2000);
                                        }
                                    });
                                    
                                } else {
                                    this.toastContent = '请输入详细地址'; this.toastPopup = true
                                    setTimeout(() => {  this.toastPopup = false;}, 2000);
                                }
                            } else {
                                this.toastContent = '请选择地区'; this.toastPopup = true
                                setTimeout(() => {  this.toastPopup = false;}, 2000);
                            }
                        } else {
                            this.toastContent = '请输入正确的手机号'; this.toastPopup = true
                            setTimeout(() => {  this.toastPopup = false;}, 2000);
                        }
                    }else{
                        this.toastContent = '手机号码未填写'; this.toastPopup = true
                        setTimeout(() => {  this.toastPopup = false;}, 2000);
                    }
                } else {
                    this.toastContent = '请填写正确的收货人姓名'; this.toastPopup = true
                    setTimeout(() => {  this.toastPopup = false;}, 2000);
                }
            }else{
                this.toastContent = '收货人姓名未填写'; this.toastPopup = true
                setTimeout(() => {  this.toastPopup = false;}, 2000);
            }
        },
        // 点击列表（省或市）选择
        selectitem(i,str) {
            if(str=='p'){
                // this.isshowcity = true;
                this.isshowprovince = false;
                this.province = i;
                this.city = "请选择";
                if (i == "北京市") {
                    this.cityarr = ["东城","西城","朝阳","丰台","石景山","海淀","门头沟","房山","通州","顺义","昌平","大兴","平谷","怀柔","密云","延庆","其它"];
                } else if (i == "天津市") {
                    this.cityarr = ["天津","和平","东丽","河东","西青","河西","津南","南开","北辰","河北","武清","红桥","塘沽","汉沽","大港","宁河","静海","宝坻","蓟县","其它"];
                } else if (i == "河北省") {
                    this.cityarr = ["石家庄","保定","北戴河","沧州","承德","丰润","邯郸","衡水","廊坊","南戴河","秦皇岛","唐山","新城","邢台","张家口","其它"];
                } else if (i == "山西省") {
                    this.cityarr = ["太原","长治","大同","侯马","晋城","离石","临汾","宁武","朔州","沂州","阳泉","榆次","运城","其它"];
                } else if (i == "内蒙古") {
                    this.cityarr = ["呼和浩特","阿拉善盟","包头","赤峰","东胜","海拉尔","集宁","临河","通辽","乌海","乌兰浩特","锡林浩特","其它",];
                } else if (i == "辽宁省") {
                    this.cityarr = ["沈阳","鞍山","本溪","朝阳","大连","丹东","抚顺","阜新","葫芦岛","锦州","辽阳","盘锦","铁岭","营口","其它"];
                } else if (i == "吉林省") {
                    this.cityarr = ["长春","吉林","白城","白山","珲春","辽源","梅河","四平","松原","通化","延吉","其它"];
                } else if (i == "黑龙江省") {
                    this.cityarr = ["哈尔滨","北安","大庆","大兴安岭","鹤岗","黑河","佳木斯","鸡西","牡丹江","齐齐哈尔","七台河","双鸭山","绥化","伊春","其它"];
                } else if (i == "上海市") {
                    this.cityarr = ["崇明","黄浦","卢湾","徐汇","长宁","静安","普陀","闸北","虹口","杨浦","闵行","宝山","嘉定","浦东","金山","松江","青浦","南汇","奉贤","其它"];
                } else if (i == "江苏省") {
                    this.cityarr = ["南京","常熟","常州","海门","淮安","江都","江阴","昆山","连云港","南通","启东","沭阳","宿迁","苏州","太仓","泰州","同里","无锡","徐州","盐城","宜兴","仪征","张家港","镇江","周庄","其它"];
                } else if (i == "浙江省") {
                    this.cityarr = ["杭州","安吉","慈溪","定海","奉化","海盐","黄岩","湖州","嘉兴","金华","临安","临海","丽水","宁波","瓯海","平湖","千岛湖","衢州","江山","瑞安","绍兴","嵊州","台州","温岭","温州","余姚","舟山","其它"];
                } else if (i == "安徽省") {
                    this.cityarr = ["合肥","安庆","蚌埠","亳州","巢湖","滁州","阜阳","贵池","淮北","淮南","黄山","九华山","六安","马鞍山","宿州","铜陵","屯溪","芜湖","宣城","其它"];
                } else if (i == "福建省") {
                    this.cityarr = ["福州","厦门","泉州","漳州","龙岩","南平","宁德","莆田","三明","其它"];
                } else if (i == "江西省") {
                    this.cityarr = ["南昌","抚州","赣州","吉安","景德镇","井冈山","九江","庐山","萍乡","上饶","新余","宜春","鹰潭","其它"];
                } else if (i == "山东省") {
                    this.cityarr = ["济南","滨州","德州","东营","菏泽","济宁","莱芜","聊城","临沂","蓬莱","青岛","曲阜","日照","泰安","潍坊","威海","烟台","枣庄","淄博","其它"];
                } else if (i == "河南省") {
                    this.cityarr = ["郑州","安阳","鹤壁","潢川","焦作","济源","开封","漯河","洛阳","南阳","平顶山","濮阳","三门峡","商丘","新乡","信阳","许昌","周口","驻马店","其它"];
                } else if (i == "湖北省") {
                    this.cityarr = ["武汉","恩施","鄂州","黄冈","黄石","荆门","荆州","潜江","十堰","随州","武穴","仙桃","咸宁","襄阳","襄樊","孝感","宜昌","其它"];
                } else if (i == "湖南省") {
                    this.cityarr = ["长沙","常德","郴州","衡阳","怀化","吉首","娄底","邵阳","湘潭","益阳","岳阳","永州","张家界","株洲","其它"];
                } else if (i == "广东省") {
                    this.cityarr = ["广州","深圳","珠海","东莞","中山","佛山","惠州","河源","潮州","江门","揭阳","茂名","梅州","清远","汕头","汕尾","韶关","顺德","阳江","云浮","湛江","肇庆","其它"];
                } else if (i == "广西自治区") {
                    this.cityarr = ["南宁","百色","北海","桂林","防城港","贵港","河池","贺州","柳州","钦州","梧州","玉林","其它"];
                } else if (i == "海南省") {
                    this.cityarr = ["海口","儋县","陵水","琼海","三亚","通什","万宁","其它"];
                } else if (i == "重庆市") {
                    this.cityarr = ["万州","涪陵","渝中","大渡口","江北","沙坪坝","九龙坡","南岸","北碚","万盛","双桥","渝北","巴南","黔江","长寿","綦江","潼南","铜梁","大足","荣昌","璧山","梁平","城口","丰都","垫江","武隆","忠县","开县","云阳","奉节","巫山","巫溪","石柱","秀山","酉阳","彭水","江津","合川","永川","南川","其它"];
                } else if (i == "四川省") {
                    this.cityarr = ["成都","巴中","达川","德阳","都江堰","峨眉山","涪陵","广安","广元","九寨沟","康定","乐山","泸州","马尔康","绵阳","眉山","南充","内江","攀枝花","遂宁","汶川","西昌","雅安","宜宾","自贡","资阳","其它"];
                } else if (i == "贵州省") {
                    this.cityarr = ["贵阳","安顺","毕节","都匀","凯里","六盘水","铜仁","兴义","玉屏","遵义","其它"];
                } else if (i == "云南省") {
                    this.cityarr = ["昆明","大理","保山","楚雄","东川","个旧","景洪","开远","临沧","丽江","六库","潞西","曲靖","思茅","文山","西双版纳","玉溪","中甸","昭通","其它"];
                } else if (i == "西藏自治区") {
                    this.cityarr = ["拉萨","阿里","昌都","林芝","那曲","日喀则","山南","其它"];
                } else if (i == "陕西省") {
                    this.cityarr = ["西安","安康","宝鸡","汉中","渭南","商州","绥德","铜川","咸阳","延安","榆林","其它"];
                } else if (i == "甘肃省") {
                    this.cityarr = ["兰州","白银","定西","敦煌","甘南","金昌","酒泉","临夏","平凉","天水","武都","武威","西峰","张掖","其它"];
                } else if (i == "青海省") {
                    this.cityarr = ["西宁","德令哈","格尔木","共和","海东","海晏","玛沁","同仁","玉树","其它"];
                } else if (i == "宁夏回族自治区") {
                    this.cityarr = ["银川", "固源", "石嘴山", "吴忠", "其它"];
                } else if (i == "新疆维吾尔自治区") {
                    this.cityarr = ["乌鲁木齐","阿克苏","阿勒泰","阿图什","博乐","昌吉","东山","哈密","和田","喀什","克拉玛依","库车","库尔勒","奎屯","石河子","塔城","吐鲁番","伊宁","其它"];
                } else if (i == "香港特别行政区") {
                    this.cityarr = ["香港", "九龙", "新界", "其它"];
                } else if (i == "澳门特别行政区") {
                    this.cityarr = ["澳门", "其它"];
                } else if (i == "台湾省") {
                    this.cityarr = ["台北","基隆","台南","台中","高雄","屏东","南投","云林","新竹","彰化","苗栗","嘉义","花莲","桃园","宜兰","台东","金门","马祖","澎湖","其它"];
                } else if (i == "其它") {
                    this.cityarr = ["其它"];
                }
            }else if(str=='c'){
                this.isshowcity = false;
                this.isshowprovince = false;
                this.city = i
            }
            
            
        },
        // 显示省或市列表
        clickprovince(res) {
        if (res == "p") {
            this.isshowprovince = !this.isshowprovince;
            this.isshowcity = false;
        } else if (res == "c") {
            this.isshowprovince = false;
            this.isshowcity = !this.isshowcity;
        }
        },
    }
}
</script>
<style scoped lang="less">
.positionabsolute{
    position:absolute;
    left:50%;
    top:50%;
    transform:translate(-50%,-50%);
}
    .mask{
        width: 100%;
        height: 100%;
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 100;
        font-family: puhui;
        .loading{
            font-size:0.3rem;
            .pswp__preloader__icn {
                opacity:0.75;
                width: 1rem;
                height: 1rem;
                -webkit-animation: clockwise 500ms linear infinite;
                animation: clockwise 500ms linear infinite;
              }
               
              /* The idea of animating inner circle is based on Polymer loading indicator by Keanu Lee https://blog.keanulee.com/2014/10/20/the-tale-of-three-spinners.html */
              .pswp__preloader__cut {
                position: relative;
                width: 0.5rem;
                height: 1rem;
                overflow: hidden;
                position: absolute;
                top: 0;
                left: 0;
              }
               
              .pswp__preloader__donut {
                box-sizing: border-box;
                width: 1rem;
                height: 1rem;
                border: 2px solid #fff;
                 border-radius: 50%;
                border-left-color: transparent;
                border-bottom-color: transparent;
                position: absolute;
                top: 0;
                left: 0;
                background: none;
                margin:0;
                //  -webkit-animation: donut-rotate 1000ms cubic-bezier(.4,0,.22,1) infinite;
                animation: donut-rotate 1000ms cubic-bezier(.4,0,.22,1) infinite;
              }
               
              @-webkit-keyframes clockwise {
                0% { -webkit-transform: rotate(0deg) }
                100% { -webkit-transform: rotate(360deg) }
              }
              @keyframes clockwise {
                0% { transform: rotate(0deg) }
                100% { transform: rotate(360deg) }
              }
              @-webkit-keyframes donut-rotate {
                0% { -webkit-transform: rotate(0) }
                50% { -webkit-transform: rotate(-140deg) }
                100% { -webkit-transform: rotate(0) }
              }
              @keyframes donut-rotate {
                0% { transform: rotate(0) }
                50% { transform: rotate(-140deg) }
                100% { transform: rotate(0) }
              }
              .title{
                color: #ffffff;
                position: absolute;
                left: 50%;
                top: 1.3rem;
                transform: translateX(-50%);
                white-space: nowrap;
            }
        }
        // 双十一兑换券提示框
        .double-eleven-coin-certificate{
            width: 6.16rem;
            height: 4.43rem;
            background: url('https://res.xiaoxxx.com/test/m.xiaoxxx.com/202111059ac64206de887c01594136.png') no-repeat center;
            background-size: cover;
            .close-acquisition{
                width: 0.8rem;
                height: 0.81rem;
                background: url('https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211028212e164e5350014a601211.png') no-repeat center;
                background-size: cover;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: -1.28rem;
            }
        }
    }
.toast{
    box-sizing: border-box;
    padding: 0.1rem 0.5rem;
    border-radius: 0.05rem;
    font-family: puhui;
    font-size: 0.24rem;
    background: rgba(0, 0, 0, 0.5);
    color: #ffffff;
    position: fixed;
    left: 50%;
    transform: translate(-50%,-50%);
    top: 50%;
    z-index: 1000;
}
.address{
    // background-color: #f9f9f9;
    // background: linear-gradient(to bottom left, rgba(255,150,13,0.1),#ffffff);
    width: 100%;
    height: 100vh;
    font-family: puhui;
    overflow-x: hidden;
    overflow-y: scroll;
}
.address::-webkit-scrollbar{
	display: none
}
.shipping-address-content{
    box-sizing: border-box;
    font-size: 0.3rem;
    padding-top: 0.2rem;
    padding: 0.2rem 0.5rem 1rem;
    text-align: left;
    .input_box1 {
        border-bottom: solid 1px #f6f6f6;
        margin: 0 0 0.2rem;
        width: 100%;
        box-sizing: border-box;
        padding-bottom: 0.29rem;
    }
    .input_box2 {
        border-bottom: solid 1px #f6f6f6;
        margin: 0 0 0.2rem;
        width: 100%;
        box-sizing: border-box;
        padding-bottom: 0.29rem;
    }
    .input_box3 {
        border-bottom: solid 1px #f6f6f6;
        margin: 0 0 0.2rem;
        width: 100%;
        box-sizing: border-box;
        padding-bottom: 0.29rem;
        position: relative;
        height: 1.16rem;
    }
    .input_box4 {
        border-bottom: solid 1px #f6f6f6;
        margin: 0 0 0.2rem;
        width: 100%;
        box-sizing: border-box;
        padding-bottom: 0.29rem;
    }
    .input_box5 {
        margin: 0 0 0.2rem;
        width: 100%;
        box-sizing: border-box;
        padding-bottom: 0.29rem;
    }
    .input_title {
        // width: 1.4rem;
        white-space: nowrap;
        text-align: right;
        margin: 0.23rem 0;
        font-size: 0.3rem;
        // position: relative;
        box-sizing: border-box;
        padding-right: 0.2rem;
        span{
            color: #ff3939;
            // margin-left: 0.1rem;
        }
    }
    .input {
        width: 100%;
        font-size: 0.3rem;
        // margin-left: 0.3rem;
    }
    .input {
        font-size: 0.3rem;
        color: #000000;
        letter-spacing: 0;
        // text-align: left;
        // position: relative;
    }
    .input_title_address {
        // margin-top: 0.35rem;
    }
    input,textarea {
        border: none;
        outline: none;
        background: none;
        resize: none;
        margin: 0;
        padding: 0;
        width: 4.85rem;
        color: #000000;
        font-size: 0.3rem;
        font-family: puhui;
        // font-weight: bold;
    }
    textarea{
        height: 1.5rem;
        width: 100%;
        border-radius: 0.14rem;
        box-sizing: border-box;
        padding: 0.19rem;
        // background: #efefef;
    }
    input::placeholder,textarea::placeholder {
        color: #aaaaaa;
    }
    .province,.city {
        padding: 0;
        // max-width: 1rem;
        // margin-left: 0.3rem;
        height: 1rem;
        position: absolute;
        top: 0.25rem;
        color: #000000;
        font-size: 0.3rem;
        // font-weight: bold;
        letter-spacing: 0.025rem;
        // line-height: 1rem;
        text-align: left;
        // padding-left: 0.15rem;
        padding-right: 0.6rem;
        background: url("//res.xiaoxxx.com/test/m.xiaoxxx.com/202107086e8bafade4c6f453757362.png") right 9% no-repeat;
        background-size: 0.36rem 0.15rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        // width: 4.85rem;
        box-sizing: border-box;
    }
    .city {
        background: none;
        position: absolute;
        background: url("//res.xiaoxxx.com/test/m.xiaoxxx.com/202107086e8bafade4c6f453757362.png") right 9% no-repeat;
        background-size: 0.36rem 0.15rem;
        left: 3.3rem;
    }
    .provincebox {
        width: 2.5rem;
        max-height: 5rem;
        position: absolute;
        top: 0.7rem;
        left: 1.3rem;
        overflow-y: scroll;
        overflow-x: hidden;
        background-color: #ffffff;
        border-radius: 0.1rem;
        border: 0.01rem solid #e4e7ed;
        z-index: 1;
        
    }
    .city-select{
        left: 3.1rem;
    }
    .select-con {
        box-sizing: border-box;
        text-align: left;
        width: 100%;
        color: #000000;
        padding: 0 0.2rem;
    }
    .btn-box{
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        box-sizing: border-box;
        padding: 0.5rem 0 0;
        background-color: #ffffff;
        height: 2.1rem;
    }
    .input_box5{
        margin-bottom: 2.6rem;
    }
    .edit_address_btn{
        box-sizing: border-box;
        height: 0.71rem;
        background: url('https://res.xiaoxxx.com/test/m.xiaoxxx.com/202110285208833dd57c4631381683.png') no-repeat center;
        background-size: cover;
        width: 2.8rem;
        margin: 0 auto 0;
    }
    .btn-title{
        font-size: 0.2rem;
            color: #9b9b9b;
            text-align: center;
            margin-top: 0.2rem;
    }
    .prize{
        margin-bottom: 0.3rem;
    }
    .prize-no{
        font-family: puhui;
    }
    .prize-img{
        width: 2rem;
        background-color: #efefef;
        border-radius: 0.13rem;
        overflow: hidden;
        margin-bottom: 0.2rem;
        box-sizing: border-box;
        padding: 0.1rem;
        text-align: center;
        font-family: puhui;
        font-size: 0.24rem;
        .prize-img-box{
            width: 100%;
            height: 2.3rem;
            img{
                max-width: 100%;
                max-height: 2rem;
                display: block;
                margin-bottom: 0.2rem;
            }
        }
        .prize-num{
            font-size: 0.28rem;
            font-weight: bold;
            margin-top: 0.2rem;
            color: #fe3835;
        }
    }
    .prize-list{
        width: 100%;
    }
}
</style>